// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  overflow-x: hidden; /* Prevent scroll on narrow devices */
}

/* body {
  padding-top: 56px;
} */

@media (max-width: 767.98px) {
  .offcanvas-collapse {
    position: fixed;
    top: 56px; /* Height of navbar */
    bottom: 0;
    width: 100%;
    padding-right: 1rem;
    padding-left: 1rem;
    overflow-y: auto;
    background-color: var(--gray-dark);
    transition: transform .3s ease-in-out;
    transform: translateX(100%);
  }
  .offcanvas-collapse.open {
    transform: translateX(-1rem); /* Account for horizontal padding on navbar */
  }
}

.nav-scroller {
  position: relative;
  z-index: 2;
  height: 2.75rem;
  overflow-y: hidden;
}

.nav-scroller .nav {
  display: flex;
  flex-wrap: nowrap;
  padding-bottom: 1rem;
  margin-top: -1px;
  overflow-x: auto;
  color: rgba(255, 255, 255, .75);
  text-align: center;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
}

.nav-underline .nav-link {
  padding-top: .75rem;
  padding-bottom: .75rem;
  font-size: .875rem;
  color: var(--secondary);
}

.nav-underline .nav-link:hover {
  color: var(--blue);
}

.nav-underline .active {
  font-weight: 500;
  color: var(--gray-dark);
}

.text-white-50 { color: rgba(255, 255, 255, .5); }

.bg-purple { background-color: var(--purple); }

.border-bottom { border-bottom: 1px solid #e5e5e5; }

.box-shadow { box-shadow: 0 .25rem .75rem rgba(0, 0, 0, .05); }

.lh-100 { line-height: 1; }
.lh-125 { line-height: 1.25; }
.lh-150 { line-height: 1.5; }`, "",{"version":3,"sources":["webpack://./src/assests/css/main_styles.css"],"names":[],"mappings":"AAAA;;EAEE,kBAAkB,EAAE,qCAAqC;AAC3D;;AAEA;;GAEG;;AAEH;EACE;IACE,eAAe;IACf,SAAS,EAAE,qBAAqB;IAChC,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,kCAAkC;IAElC,qCAAqC;IAGrC,2BAA2B;EAC7B;EACA;IAEE,4BAA4B,EAAE,6CAA6C;EAC7E;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,kBAAkB;AACpB;;AAEA;EAGE,aAAa;EAEb,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,iBAAiB,8BAA8B,EAAE;;AAEjD,aAAa,+BAA+B,EAAE;;AAE9C,iBAAiB,gCAAgC,EAAE;;AAEnD,cAAc,8CAA8C,EAAE;;AAE9D,UAAU,cAAc,EAAE;AAC1B,UAAU,iBAAiB,EAAE;AAC7B,UAAU,gBAAgB,EAAE","sourcesContent":["html,\nbody {\n  overflow-x: hidden; /* Prevent scroll on narrow devices */\n}\n\n/* body {\n  padding-top: 56px;\n} */\n\n@media (max-width: 767.98px) {\n  .offcanvas-collapse {\n    position: fixed;\n    top: 56px; /* Height of navbar */\n    bottom: 0;\n    width: 100%;\n    padding-right: 1rem;\n    padding-left: 1rem;\n    overflow-y: auto;\n    background-color: var(--gray-dark);\n    transition: -webkit-transform .3s ease-in-out;\n    transition: transform .3s ease-in-out;\n    transition: transform .3s ease-in-out, -webkit-transform .3s ease-in-out;\n    -webkit-transform: translateX(100%);\n    transform: translateX(100%);\n  }\n  .offcanvas-collapse.open {\n    -webkit-transform: translateX(-1rem);\n    transform: translateX(-1rem); /* Account for horizontal padding on navbar */\n  }\n}\n\n.nav-scroller {\n  position: relative;\n  z-index: 2;\n  height: 2.75rem;\n  overflow-y: hidden;\n}\n\n.nav-scroller .nav {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  padding-bottom: 1rem;\n  margin-top: -1px;\n  overflow-x: auto;\n  color: rgba(255, 255, 255, .75);\n  text-align: center;\n  white-space: nowrap;\n  -webkit-overflow-scrolling: touch;\n}\n\n.nav-underline .nav-link {\n  padding-top: .75rem;\n  padding-bottom: .75rem;\n  font-size: .875rem;\n  color: var(--secondary);\n}\n\n.nav-underline .nav-link:hover {\n  color: var(--blue);\n}\n\n.nav-underline .active {\n  font-weight: 500;\n  color: var(--gray-dark);\n}\n\n.text-white-50 { color: rgba(255, 255, 255, .5); }\n\n.bg-purple { background-color: var(--purple); }\n\n.border-bottom { border-bottom: 1px solid #e5e5e5; }\n\n.box-shadow { box-shadow: 0 .25rem .75rem rgba(0, 0, 0, .05); }\n\n.lh-100 { line-height: 1; }\n.lh-125 { line-height: 1.25; }\n.lh-150 { line-height: 1.5; }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
